import { CodeIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Code = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CodeIcon {...rest} size={Sizes[size]} color={fill} />;
};

Code.displayName = 'Code';
